import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import CarouselImages from './components/CarouselImages';
import CarouselProgrammes from './components/CarouselProgrammes';
import locomotiveScroll from './components/LocomotiveScroll';
import Menu from './components/Menu';
import ResponsiveVideo from './components/ResponsiveVideo';

export class Bureau {
	constructor() {
		// Promises waarop gewacht  wordt. Standaard wordt er gewacht op het 'DOMContentLoaded' event
		Promise.all([Bureau.domReady()]).then(() => this.init());
	}

	init() {
		document.dispatchEvent(new Event('bless'));

		document.fonts.ready.then(() => {
			locomotiveScroll.init();
		});

		new Menu();

		ResponsiveVideo.init();

		document.querySelectorAll('[data-carousel-images]').forEach(elm => {
			new CarouselImages(elm);
		});

		document.querySelectorAll('[data-carousel-programmes]').forEach(elm => {
			new CarouselProgrammes(elm);
		});

		this.portfolio = document.querySelectorAll('[data-case="mouseover"]');

		this.portfolio.forEach(elm => {

			elm.addEventListener('mouseover', e => {
				this.portfolio.forEach(elm => {
					elm.classList.remove('is-active');
				});
				elm.classList.add('is-active');
			});
		});


	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new Bureau();

